module.exports = __webpack_public_path__ + "static/media/aeronave.7f040b57.png";